export const otherColors = {
  trustPilotBlack: '#000',
  trustPilotGrey: '#696A6A',
} as const;
